import { FEATURES } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'
import { canShowFiniaRoute } from '@modules/finia/utils/permissions/permissions'

export default [
  {
    // Rota única e sem shell de módulo: a Finia é uma aplicação externa embarcada
    // que ocupa toda a área de conteúdo e traz o próprio cabeçalho. Um nav-bar
    // AAWZ acima dele duplicaria a identidade da página e subtrairia altura do
    // embed — que é o recurso escasso desta tela.
    // Divergência consciente da regra de shell de nav-bar do design-system
    // (`design-system:no-regression`), registrada como `justificativa_na` no corpo
    // do PR. É a única regra do gate que este módulo não cumpre: `checkFile()`
    // aplicado a cada arquivo de `src/modules/finia/` retorna zero achado (o modo
    // `--target` não chega a rodar essas checagens — ele lança no erro de shell
    // antes, então a verificação tem de ser feita por `checkFile()`).
    //
    // A regra não é oráculo confiável: ela procura o shell em quatro caminhos
    // fixos (design-system-no-regression-check.js:40-43) em vez de verificar se
    // ele existe. Brokkr e Power BI têm shell e mesmo assim saem 1 no gate, por
    // guardarem o arquivo em subpasta própria — ou seja, o gate já falha em
    // código mergeado. Registrando o fato que a revisão anterior corrigiu: o
    // Brokkr tem shell com uma única rota filha, então o precedente dele NÃO
    // sustenta a ausência de shell aqui; o que sustenta é o cabeçalho duplicado.
    // A URL acompanha o rótulo exibido ("Rotina Financeira"). O `name` segue
    // `finia` — identificador interno pareado com ROUTE_KEYS.FINIA, com a pasta
    // do módulo e com o nome da aplicação externa embarcada.
    path: '/rotina-financeira',
    name: 'finia',
    // Mesmo gate do item de menu: sem a funcionalidade "Plataforma BPO Financeiro"
    // ou sem perfil financeiro, o acesso direto pela URL cai no 404 (guard em
    // src/router/index.js). O bloqueio efetivo é o `customPermission`: no bloco
    // de `permission` do guard, ter a `can_show` já satisfaz a checagem, então a
    // lista de roles abaixo documenta a intenção mas não barra sozinha.
    meta: {
      permission: ['gestor', 'financeiro'],
      can_show: FEATURES.PLATAFORMA_BPO_FINANCEIRO,
      customPermission: ({ user, show }) =>
        canShowFiniaRoute({ user, access: show }),
    },
    component: () =>
      lazyLoadView(import('@modules/finia/views/view-finia.vue')),
  },
]
